import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { HashRouter as Router } from 'react-router-dom';
import { Nav, NavItem } from 'reactstrap';
import linkData from '../../data/linkData.json';

function FedsearchNav(props: any) {
  return (
    <Router>
      <Nav vertical>
        {
          linkData.map(link => 
            <NavItem key={link.url}>
              <Link className="nav-link" to={`#${link.url}`}>
                <span className={props.selected === link.url ? 'selected' : ''}>{link.display}</span>
              </Link>
            </NavItem>
          )
        }
      </Nav>
    </Router>
  );
};

export default FedsearchNav;
